import { canonicalizeStyleTypeName } from '../beerStyle/styleTypeAliases';

/**
 * Validates styleType against the allowlist (case-insensitive).
 */
export function validateStyleType(rawStyleType, allowedTypeNames = []) {
  const trimmed = typeof rawStyleType === 'string' ? rawStyleType.trim() : '';
  if (!trimmed) {
    return { styleType: null, error: 'Style type is required when style is not in catalog' };
  }

  const allowedLookup = new Map(
    (allowedTypeNames || []).map((typeName) => [typeName.toLowerCase(), typeName]),
  );
  const exact = allowedLookup.get(trimmed.toLowerCase());
  if (exact) {
    return { styleType: exact, error: null };
  }

  const canonical = canonicalizeStyleTypeName(trimmed);
  if (allowedLookup.size === 0) {
    return { styleType: canonical, error: null };
  }
  const allowed = allowedLookup.get(canonical.toLowerCase());
  if (!allowed) {
    return { styleType: null, error: `Style type "${trimmed}" is not allowed` };
  }

  return { styleType: allowed, error: null };
}
